import React, { useState, useEffect } from 'react';
import { TextInput } from '../input';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const ListFilter = ({
	changeQueryFilterDebounced,
}) => {

	// Fully uncontrolled ListFilter.

	// NOTE: this cannot be a controlled component. If so, it becomes too jerky,
	// as the value to be passed in comes from the parent, which has some heavy
	// loading coming from the back-end. The cleanest way is to let this component
	// maintain its own value, and then call the passed in changeQueryFilter
	// after its own internal state changes. It can debounce too, from here,
	// rather than from any parent component.

	const [value, setValue] = useState(undefined);
	const styles = useThemedStyles(createStyles);

	// Checking if value is !== undefined avoids changeQueryFilter from firing on
	// the first render, because there is not yet a query string.
	useEffect(() => {
		if (value !== undefined) {
			changeQueryFilterDebounced(value);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	return (
		<TextInput
			onChange={setValue}
			value={value || ''}
			placeholder="Filter..."
			style={styles.input}
		/>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	input: {
		backgroundColor: colors.card,
		flex: 1,
		minWidth: 0,
		marginBottom: 0,
	},
});

export default ListFilter;
